import { AuthService } from '../service/auth.service';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(private authService: AuthService) {
  }

  canActivate() {
    return this.authService
      .init()
      .pipe(
        map(userId => !!userId),
        catchError(error => {
          const placeholder = document.getElementById('pre-loader');

          if (placeholder && placeholder.children[1]) {
            placeholder.children[1].innerHTML = 'Error';
          }

          return throwError(error);
        })
      );
  }

}
